import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import type { GlobalSearchResultsDto } from '@/features/dashboard/globalSearch/types/GlobalSearchResultsDto.ts';

/** Minimalna długość frazy — ta sama, od której backend stosuje `searchTerm`. */
export const GLOBAL_SEARCH_MIN_TERM_LENGTH = 2;

const globalSearchApi = {
  search: (term: string, includeCancelled: boolean) =>
    fetchPrivateApi<GlobalSearchResultsDto>(
      'GET',
      `search?query=${encodeURIComponent(term)}&includeCancelled=${includeCancelled}`,
    ),
};

export default globalSearchApi;
